import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiUrl } from '../config/api';
import * as XLSX from 'xlsx';
import './GestionProducto.css';

const obtenerPrimerDiaMes = () => {
    const hoy = new Date();
    return new Date(hoy.getFullYear(), hoy.getMonth(), 1).toISOString().split('T')[0];
};

const obtenerFechaHoy = () => new Date().toISOString().split('T')[0];

const formatearFecha = (fecha) => {
    if (!fecha) return '';
    const [year, month, day] = fecha.split('-');
    return `${day}/${month}/${year}`;
};

function CGAsientos() {
    const [asientos, setAsientos] = useState([]);
    const [asientosFiltrados, setAsientosFiltrados] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [fechaDesde, setFechaDesde] = useState(obtenerPrimerDiaMes());
    const [fechaHasta, setFechaHasta] = useState(obtenerFechaHoy());
    const [cargando, setCargando] = useState(false);

    // Paginacion
    const [paginaActual, setPaginaActual] = useState(1);
    const [itemsPorPagina, setItemsPorPagina] = useState(20);

    useEffect(() => {
        cargarAsientos();
    }, []);

    useEffect(() => {
        filtrarAsientos();
    }, [busqueda, asientos]);

    const cargarAsientos = async () => {
        setCargando(true);
        try {
            const response = await axios.get(getApiUrl('/api/asientos'), {
                params: { fechaDesde, fechaHasta }
            });
            setAsientos(response.data);
            setAsientosFiltrados(response.data);
        } catch (error) {
            console.error('Error al cargar asientos:', error);
            alert('Error al cargar los asientos contables');
        } finally {
            setCargando(false);
        }
    };

    const filtrarAsientos = () => {
        if (!busqueda) {
            setAsientosFiltrados(asientos);
            setPaginaActual(1);
            return;
        }

        const filtrados = asientos.filter(a =>
            a.asiento?.toString().includes(busqueda) ||
            a.descripcion?.toLowerCase().includes(busqueda.toLowerCase()) ||
            a.sysGenera?.toLowerCase().includes(busqueda.toLowerCase()) ||
            a.idOperador?.toLowerCase().includes(busqueda.toLowerCase())
        );
        setAsientosFiltrados(filtrados);
        setPaginaActual(1);
    };

    const exportarExcel = () => {
        const datosExportar = asientosFiltrados.map(a => ({
            'Sucursal': a.sucursal,
            'Asiento': a.asiento,
            'Fecha': a.fecha ? formatearFecha(a.fecha) : '',
            'Descripcion': a.descripcion,
            'Total Debito': a.totalDebito,
            'Total Credito': a.totalCredito,
            'Sistema': a.sysGenera,
            'Operador': a.idOperador,
            'Division': a.idDivision
        }));

        const worksheet = XLSX.utils.json_to_sheet(datosExportar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Asientos');
        XLSX.writeFile(workbook, 'asientos_contables.xlsx');
    };

    // Paginacion
    const indiceUltimo = paginaActual * itemsPorPagina;
    const indicePrimero = indiceUltimo - itemsPorPagina;
    const asientosActuales = asientosFiltrados.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(asientosFiltrados.length / itemsPorPagina);

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
    };

    const cambiarItemsPorPagina = (e) => {
        setItemsPorPagina(Number(e.target.value));
        setPaginaActual(1);
    };

    return (
        <div className="present-container">
            <div className="header-seccion">
                <h2>Asientos Contables</h2>
                <div className="acciones-header">
                    <input
                        type="text"
                        className="input-busqueda"
                        placeholder="Buscar..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                    <button className="btn btn-exportar" onClick={exportarExcel}>
                        Exportar a Excel
                    </button>
                </div>
            </div>

            {/* Filtro de fechas */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                padding: '15px',
                backgroundColor: '#f5f5f5',
                borderRadius: '8px',
                marginBottom: '15px',
                flexWrap: 'wrap'
            }}>
                <label style={{ fontSize: '14px', color: '#555', fontWeight: '500' }}>Desde:</label>
                <input
                    type="date"
                    value={fechaDesde}
                    onChange={(e) => setFechaDesde(e.target.value)}
                    style={{
                        padding: '8px 12px',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        fontSize: '14px'
                    }}
                />
                <label style={{ fontSize: '14px', color: '#555', fontWeight: '500' }}>Hasta:</label>
                <input
                    type="date"
                    value={fechaHasta}
                    onChange={(e) => setFechaHasta(e.target.value)}
                    style={{
                        padding: '8px 12px',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        fontSize: '14px'
                    }}
                />
                <button
                    className="btn btn-nuevo"
                    onClick={cargarAsientos}
                    disabled={cargando}
                >
                    {cargando ? 'Cargando...' : 'Consultar'}
                </button>
                <span style={{ fontSize: '13px', color: '#7f8c8d' }}>
                    {asientosFiltrados.length} registros encontrados
                </span>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead>
                        <tr>
                            <th>Sucursal</th>
                            <th>Asiento</th>
                            <th>Fecha</th>
                            <th>Descripcion</th>
                            <th style={{ textAlign: 'right' }}>Total Debito</th>
                            <th style={{ textAlign: 'right' }}>Total Credito</th>
                            <th>Sistema</th>
                            <th>Operador</th>
                            <th>Division</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cargando ? (
                            <tr>
                                <td colSpan="9" className="sin-datos">Cargando datos...</td>
                            </tr>
                        ) : asientosActuales.length === 0 ? (
                            <tr>
                                <td colSpan="9" className="sin-datos">No hay asientos para mostrar en el periodo seleccionado</td>
                            </tr>
                        ) : (
                            asientosActuales.map(asiento => (
                                <tr key={`${asiento.sucursal}-${asiento.asiento}`}>
                                    <td>{asiento.sucursal}</td>
                                    <td>{asiento.asiento}</td>
                                    <td>{asiento.fecha ? formatearFecha(asiento.fecha) : ''}</td>
                                    <td>{asiento.descripcion}</td>
                                    <td style={{ textAlign: 'right' }}>
                                        {asiento.totalDebito?.toLocaleString('es-PY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </td>
                                    <td style={{ textAlign: 'right' }}>
                                        {asiento.totalCredito?.toLocaleString('es-PY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </td>
                                    <td>{asiento.sysGenera}</td>
                                    <td>{asiento.idOperador}</td>
                                    <td>{asiento.idDivision}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Paginacion */}
            <div className="paginacion-container">
                <div className="paginacion-info">
                    <span>
                        Mostrando {asientosFiltrados.length > 0 ? indicePrimero + 1 : 0} a {Math.min(indiceUltimo, asientosFiltrados.length)} de {asientosFiltrados.length} registros
                    </span>
                    <select value={itemsPorPagina} onChange={cambiarItemsPorPagina} className="select-registros">
                        <option value={10}>10 por pagina</option>
                        <option value={20}>20 por pagina</option>
                        <option value={50}>50 por pagina</option>
                        <option value={100}>100 por pagina</option>
                    </select>
                </div>

                <div className="paginacion-controles">
                    <button onClick={() => cambiarPagina(1)} disabled={paginaActual === 1} className="btn-paginacion">|&lt;</button>
                    <button onClick={() => cambiarPagina(paginaActual - 1)} disabled={paginaActual === 1} className="btn-paginacion">&lt;</button>

                    {[...Array(totalPaginas)].map((_, index) => {
                        const numeroPagina = index + 1;
                        if (numeroPagina === 1 || numeroPagina === totalPaginas || (numeroPagina >= paginaActual - 1 && numeroPagina <= paginaActual + 1)) {
                            return (
                                <button key={numeroPagina} onClick={() => cambiarPagina(numeroPagina)} className={`btn-numero-pagina ${paginaActual === numeroPagina ? 'activo' : ''}`}>
                                    {numeroPagina}
                                </button>
                            );
                        } else if (numeroPagina === paginaActual - 2 || numeroPagina === paginaActual + 2) {
                            return <span key={numeroPagina}>...</span>;
                        }
                        return null;
                    })}

                    <button onClick={() => cambiarPagina(paginaActual + 1)} disabled={paginaActual === totalPaginas || totalPaginas === 0} className="btn-paginacion">&gt;</button>
                    <button onClick={() => cambiarPagina(totalPaginas)} disabled={paginaActual === totalPaginas || totalPaginas === 0} className="btn-paginacion">&gt;|</button>
                </div>
            </div>
        </div>
    );
}

export default CGAsientos;
